import {
  Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, Code, Flex, Text,
} from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import CopyButton from '../CopyButton';
import { getForm } from '../FormSetup/formSlice';
import { getFormEmbedUrl, getFormUrl } from '../../helpers';

const PublishForm = () => {
  const form = useSelector(getForm);
  return (
    <Accordion defaultIndex={[1]}>
      <AccordionItem>
        <h2>
          <AccordionButton _expanded={{ border: '1px solid', borderColor: 'blue.700', borderBottomColor: 'gray.300' }}>
            <Box as="span" flex="1" textAlign="left">
              Copy the link of your form
            </Box>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        <AccordionPanel pb={4} bg="blackAlpha.20" border="1px solid" borderColor="blue.700" borderTop="none">
          <Text fontSize="sm">
            This is the simplest way of publishing your form with a small number of people.
          </Text>
          <Code my="4" padding="2">
            {getFormUrl(form)}
          </Code>
          <Flex justify="flex-end">
            <CopyButton code={getFormUrl(form)} label="Copy link" />
          </Flex>
        </AccordionPanel>
      </AccordionItem>

      <AccordionItem>
        <h2>
          <AccordionButton _expanded={{ border: '1px solid', borderColor: 'blue.700', borderBottomColor: 'gray.300' }}>
            <Box as="span" flex="1" textAlign="left">
              Copy the embed code of your form
            </Box>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        <AccordionPanel pb={4} bg="blackAlpha.20" border="1px solid" borderColor="blue.700" borderTop="none">
          <Text fontSize="sm">
            This is the recomended way of publishing your form on your website. The height of the iframe is automatically set.
          </Text>
          <Code my="4" padding="2">
            {`<script type="text/javascript" defer src="${getFormEmbedUrl(form)}"></script>`}
          </Code>
          <Flex justify="flex-end">
            <CopyButton code={`<script type="text/javascript" defer src="${getFormEmbedUrl(form)}"></script>`} />
          </Flex>
        </AccordionPanel>
      </AccordionItem>

      <AccordionItem>
        <h2>
          <AccordionButton _expanded={{ border: '1px solid', borderColor: 'blue.700', borderBottomColor: 'gray.300' }}>
            <Box as="span" flex="1" textAlign="left">
              IFrame
            </Box>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        <AccordionPanel pb={4} bg="blackAlpha.20" border="1px solid" borderColor="blue.700" borderTop="none">
          <Text fontSize="sm">
            Inline frames have a specified height.
          </Text>
          <Code my="4" p="2">
            {`<iframe src="${getFormUrl(form)}" width="100%" height="300" frameborder="0"></iframe>`}
          </Code>
          <Flex justify="flex-end">
            {/* eslint-disable-next-line max-len */ }
            <CopyButton code={`<iframe src="${getFormUrl(form)}" width="100%" height="300" frameborder="0"></iframe>`} />
          </Flex>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};
export default PublishForm;
